import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "card-header border-0 ps-5" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "card-header border-0 cursor-pointer",
    role: "button",
    "data-bs-toggle": "collapse",
    "data-bs-target": "#kt_account_profile_details",
    "aria-expanded": "true",
    "aria-controls": "kt_account_profile_details"
  }, [
    /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
      /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, "Recruitment Details")
    ])
  ])
], -1)
const _hoisted_3 = {
  id: "kt_account_profile_details",
  class: "collapse show"
}
const _hoisted_4 = {
  key: 0,
  class: "card-body border-top p-9"
}
const _hoisted_5 = { class: "row mb-7" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-6 fw-bold text-muted" }, " Describe the recruitment strategies you will use for each group of subjects. ", -1)
const _hoisted_7 = { class: "col-lg-6 fv-row" }
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = { class: "row mb-7" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-6 fw-bold text-muted" }, " Are subjects chosen from records? ", -1)
const _hoisted_11 = { class: "col-lg-6 fv-row" }
const _hoisted_12 = { class: "fw-bold fs-6" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { class: "row mb-7" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-6 fw-bold text-muted" }, " Who gave approval for use of the records? ", -1)
const _hoisted_16 = { class: "col-lg-6 fv-row" }
const _hoisted_17 = ["innerHTML"]
const _hoisted_18 = { class: "row mb-7" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-6 fw-bold text-muted" }, " Do the records include any identifiable information? (e.g., name, address, etc.) ", -1)
const _hoisted_20 = { class: "col-lg-6 fv-row" }
const _hoisted_21 = { class: "fw-bold fs-6" }
const _hoisted_22 = {
  key: 0,
  class: "row mb-7"
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-6 fw-bold text-muted" }, " Please enter the identiable information ", -1)
const _hoisted_24 = { class: "col-lg-6 fv-row" }
const _hoisted_25 = ["innerHTML"]
const _hoisted_26 = { class: "row mb-7" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-6 fw-bold text-muted" }, " Are the records publicly available (available to anyone to access)? ", -1)
const _hoisted_28 = { class: "col-lg-6 fv-row" }
const _hoisted_29 = { class: "fw-bold fs-6" }
const _hoisted_30 = { class: "row mb-7" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-6 fw-bold text-muted" }, " Will any protected health information (PHI) be accessed or extracted from medical records for your study? See definition of PHI below. ", -1)
const _hoisted_32 = { class: "col-lg-6 fv-row" }
const _hoisted_33 = { class: "fw-bold fs-6" }
const _hoisted_34 = { key: 1 }
const _hoisted_35 = { class: "row mb-7" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-6 fw-bold text-muted" }, " How will you be accessing subject PHI? ", -1)
const _hoisted_37 = { class: "col-lg-6 fv-row" }
const _hoisted_38 = { class: "fw-bold fs-6" }
const _hoisted_39 = {
  key: 0,
  class: "row mb-7"
}
const _hoisted_40 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-6 fw-bold text-muted" }, " Others(Please Specify) ", -1)
const _hoisted_41 = { class: "col-lg-6 fv-row" }
const _hoisted_42 = ["innerHTML"]
const _hoisted_43 = { class: "row mb-7" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-6 fw-bold text-muted" }, " Will subjects receive gifts, payments, compensation, reimbursement, or extra credit for participating? ", -1)
const _hoisted_45 = { class: "col-lg-6 fv-row" }
const _hoisted_46 = { class: "fw-bold fs-6" }
const _hoisted_47 = { key: 2 }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("div", { class: "row mb-7" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "col-lg-12 fw-bold text-muted" }, " Please explain ")
], -1)
const _hoisted_49 = { class: "row mb-7" }
const _hoisted_50 = { class: "col-lg-12 fv-row" }
const _hoisted_51 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NoteSection = _resolveComponent("NoteSection")!
  const _component_ViewActions = _resolveComponent("ViewActions")!
  const _component_Documents = _resolveComponent("Documents")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_NoteSection, { type: _ctx.modalNoteType }, null, 8, ["type"]),
    _createVNode(_component_ViewActions, {
      "route-name": "view-risk-factor",
      "route-name-edit": "edit-recruitment-factor"
    }),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        (_ctx.currentRecruitment.data != null)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("span", {
                    class: "fw-bold fs-6",
                    innerHTML: _ctx.currentRecruitment.data.strategy
                  }, null, 8, _hoisted_8)
                ])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.currentRecruitment.data.areChosenFromRecord ? "Yes" : "No"), 1)
                ])
              ]),
              (!!_ctx.currentRecruitment.data.areChosenFromRecord)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _hoisted_15,
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("span", {
                          class: "fw-bold fs-6",
                          innerHTML: _ctx.currentRecruitment.data.approvedPerson
                        }, null, 8, _hoisted_17)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_18, [
                      _hoisted_19,
                      _createElementVNode("div", _hoisted_20, [
                        _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.currentRecruitment.data.hasIdentifiableInformation
                ? "Yes"
                : "No"), 1)
                      ])
                    ]),
                    (!!_ctx.currentRecruitment.data.hasIdentifiableInformation)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                          _hoisted_23,
                          _createElementVNode("div", _hoisted_24, [
                            _createElementVNode("span", {
                              class: "fw-bold fs-6",
                              innerHTML: _ctx.currentRecruitment.data.identifiableInformation
                            }, null, 8, _hoisted_25)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_26, [
                      _hoisted_27,
                      _createElementVNode("div", _hoisted_28, [
                        _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.currentRecruitment.data.hasAccess), 1)
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_30, [
                _hoisted_31,
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.currentRecruitment.data.willAccessFromRecord ? "Yes" : "No"), 1)
                ])
              ]),
              (!!_ctx.currentRecruitment.data.willAccessFromRecord)
                ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                    _createElementVNode("div", _hoisted_35, [
                      _hoisted_36,
                      _createElementVNode("div", _hoisted_37, [
                        _createElementVNode("span", _hoisted_38, _toDisplayString(_ctx.currentRecruitment.data.accessType), 1)
                      ])
                    ]),
                    (_ctx.currentRecruitment.data.accessType === 'Others(Please Specify)'
              )
                      ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                          _hoisted_40,
                          _createElementVNode("div", _hoisted_41, [
                            _createElementVNode("span", {
                              class: "fw-bold fs-6",
                              innerHTML: _ctx.currentRecruitment.data.accessTypeOther
                            }, null, 8, _hoisted_42)
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_43, [
                _hoisted_44,
                _createElementVNode("div", _hoisted_45, [
                  _createElementVNode("span", _hoisted_46, _toDisplayString(_ctx.currentRecruitment.data.willSubjectsReceiveAnything ? "Yes" : "No"), 1)
                ])
              ]),
              (!!_ctx.currentRecruitment.data.willSubjectsReceiveAnything)
                ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                    _hoisted_48,
                    _createElementVNode("div", _hoisted_49, [
                      _createElementVNode("div", _hoisted_50, [
                        _createElementVNode("span", {
                          class: "fw-bold fs-6",
                          innerHTML: _ctx.currentRecruitment.data.receiveDetail
                        }, null, 8, _hoisted_51)
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_Documents, {
      classification: "Recruitment",
      hiddeDelete: "true"
    })
  ], 64))
}